import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, Mail, Menu, X } from 'lucide-react';
import { hotelInfo } from '../data/mock';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Rooms & Tariff', path: '/rooms' },
    { name: 'Facilities', path: '/facilities' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'About Haridwar', path: '/about' },
    { name: 'Blog', path: '/blog' },
    { name: 'Contact', path: '/contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-lg' : 'bg-white/95 backdrop-blur-sm'
    }`}>
      {/* Top Bar */}
      <div className="bg-navy-900 text-white py-3 px-4">
        <div className="container mx-auto flex flex-col sm:flex-row justify-between items-center gap-2 sm:gap-4">
          <div className="flex items-center gap-3 sm:gap-6 text-sm">
            <a href={`tel:${hotelInfo?.phone || '+911234567890'}`} className="flex items-center gap-2 hover:text-gold-400 transition-colors">
              <Phone size={16} />
              <span>{hotelInfo?.phone || '+91-8941000583'}</span>
            </a>
            <a href={`mailto:${hotelInfo?.email || 'info@example.com'}`} className="flex items-center gap-2 hover:text-gold-400 transition-colors">
              <Mail size={16} />
              <span className="hidden md:inline">{hotelInfo?.email || 'info@example.com'}</span>
            </a>
          </div>
          <div className="text-sm font-medium">
            Sarvarnath Nagar, Near Har Ki Pauri, Haridwar
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between py-4">
          {/* Logo */}
          <Link to="/" className="flex flex-col">
            <h1 className="text-2xl md:text-3xl font-bold text-navy-900 font-serif">
              {hotelInfo?.name || 'Hotel Suvidha Deluxe'}
            </h1>
            <p className="text-sm text-gold-600 font-medium tracking-wide">
              {hotelInfo?.tagline || 'Your Premium Stay in the Holy City'}
            </p>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-6">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors hover:text-gold-600 ${
                  isActive(link.path) ? 'text-gold-600' : 'text-navy-800'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link to="/booking">
              <Button className="bg-gold-600 hover:bg-gold-700 text-white">
                Book Now
              </Button>
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-navy-900 p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t shadow-lg">
          <nav className="container mx-auto px-4 py-6 flex flex-col gap-2">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`py-3 px-4 text-base rounded-md transition-colors ${
                  isActive(link.path)
                    ? 'bg-gold-50 text-gold-700 font-semibold'
                    : 'text-navy-800 hover:bg-gray-50 font-medium'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link to="/booking" onClick={() => setIsMobileMenuOpen(false)} className="mt-2">
              <Button className="w-full bg-gold-600 hover:bg-gold-700 text-white py-6 text-base font-semibold">
                Book Now
              </Button>
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
